function NoticeBoard() {
  const notices = [
    "PTM on Aug 1st",
  ];

  // return (
  //   <section className="py-20 bg-gray-50">
  //     <div className="max-w-6xl mx-auto px-6">

  //       <div className="text-center mb-12">
  //         <h2 className="text-4xl font-bold text-blue-900 mb-3">
  //           Notice Board
  //         </h2>

  //         <p className="text-gray-600">
  //           Latest announcements and updates
  //         </p>
  //       </div>

  //       <div className="bg-white rounded-3xl shadow-xl overflow-hidden">

  //         {notices.map((notice, index) => (
  //           <div
  //             key={index}
  //             className="flex items-center gap-4 px-6 py-5 border-b last:border-b-0 hover:bg-yellow-50 transition"
  //           >
  //             <div className="w-3 h-3 rounded-full bg-yellow-400"></div>

  //             <p className="text-gray-700 font-medium">
  //               {notice}
  //             </p>
  //           </div>
  //         ))}

  //       </div>

  //     </div>
  //   </section>
  // );
}

export default NoticeBoard;